// extracted by css-extract-rspack-plugin
export default {"button-group":"button-group___QEmmoXBB","button-group__item":"button-group__item___m6zwXz2R","button-group__item--active":"button-group__item--active___dK_HSbGM"};